var _class, _ScrollBar;
import React, { PureComponent } from 'react';
import cn from 'classnames';

// @ts-ignore
import dragHOC from '@platform-ui/dragHOC';
import { dataQa } from '@tui-react/core';
import { pickStyle } from '@tui-react/core';
import { getScrollbarMarginStyles } from './utils';
import styles from './Scroll.module.css';
const noop = () => {};
const mainProperty = {
  vertical: 'height',
  horizontal: 'width'
};
let ScrollBar = dragHOC(_class = (_ScrollBar = class ScrollBar extends PureComponent {
  constructor(..._args) {
    super(..._args);
    // TODO: исправить после перевода dragHOC на TS
    // @ts-ignore
    this.onDragStart = (...args) => this.props.handleDragStart(...args);
    // @ts-ignore
    this.onDragProcess = (...args) => this.props.handleDragProcess(...args);
    // @ts-ignore
    this.onDragEnd = (...args) => this.props.handleDragEnd(...args);
    this.handleMouseDown = event => {
      const {
        onMouseDown,
        onDrag,
        direction
      } = this.props;
      onMouseDown(event, direction);
      onDrag(event);
    };
  }
  render() {
    const {
      visible,
      barRef,
      size,
      theme,
      dragging,
      direction,
      scrollbarMargin
    } = this.props;
    const marginStyle = getScrollbarMarginStyles(direction, scrollbarMargin);
    return /*#__PURE__*/React.createElement("div", Object.assign({}, dataQa(this.props), pickStyle(this.props, 'root', {
      className: cn({
        [styles.scrollBar]: true,
        [styles.scrollBar_visible]: visible,
        [styles.scrollBar_dragging]: dragging,
        [styles[`scrollBar_direction_${direction}`]]: true,
        [styles[`scrollBar_theme_${theme}`]]: true
      }),
      style: marginStyle
    })), /*#__PURE__*/React.createElement("div", Object.assign({}, pickStyle(this.props, 'caret', {
      className: styles.scrollCaret,
      style: {
        [mainProperty[direction]]: size
      }
    }), {
      ref: barRef,
      onMouseDown: this.handleMouseDown
    })));
  }
}, _ScrollBar.defaultProps = {
  visible: false,
  dragging: false,
  size: 0,
  theme: 'default',
  onDrag: noop,
  onMouseDown: noop,
  handleDragStart: noop,
  handleDragProcess: noop,
  handleDragEnd: noop,
  dataQaType: 'uikit/scroll-bar'
}, _ScrollBar)) || _class;
export default ScrollBar;